// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-tiny-editor .loader-wrapper[data-v-17ea45ca]{position:absolute;min-height:var(--tiny-editor-min-height);right:0;left:0;display:flex;justify-content:center;align-items:center}.app-tiny-editor[data-v-17ea45ca]  .tox.tox-tinymce{z-index:9}.close-button-wrapper[data-v-17ea45ca]{position:fixed;top:var(--spacer-lg);right:var(--spacer-lg);z-index:10;width:32px;height:32px;background:var(--v-white);border-radius:50%}", ""]);
// Exports
module.exports = exports;
